import type { OnErrorCallback, NotifiableError } from '@bugsnag/js';
import Bugsnag from '@bugsnag/js';

export default function logError(error: NotifiableError, event?: OnErrorCallback) {
  Bugsnag.notify(error, event);

  console.error(error);
}
